module.exports = __webpack_public_path__ + "img/1c5ade362b2e122c825845db4e828e21.png";